import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
} from "react";
import { useDispatch } from "react-redux";
import { getInvitationList } from "../redux/actions/invitation"; // Adjust the path as needed
import { useUser } from "./UserContext";

const InvitationsContext = createContext(undefined);

export const useInvitations = () => {
  const context = useContext(InvitationsContext);
  if (!context) {
    throw new Error("useInvitations must be used within an InvitationsProvider");
  }
  return context;
};

export const InvitationsProvider = ({ children }) => {
  const { currentUser } = useUser();
  const dispatch = useDispatch();
  const [invitations, setInvitations] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!currentUser) return;

    const fetchInvitations = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await dispatch(getInvitationList());
        // Assuming response.payload.data is an array of invitations:
        setInvitations(response.payload.data);
      } catch (err) {
        console.error("Failed to fetch invitations:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchInvitations();
  }, [currentUser, dispatch]);

  return (
    <InvitationsContext.Provider
      value={{
        invitations,
        error,
        loading,
      }}
    >
      {children}
    </InvitationsContext.Provider>
  );
};